import { render, staticRenderFns } from "./DeliverySignaturesCard.vue?vue&type=template&id=00fc40e5"
import script from "./DeliverySignaturesCard.vue?vue&type=script&lang=ts"
export * from "./DeliverySignaturesCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports